var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 677.3 46.1",
    style: {
      enableBackground: "new 0 0 677.3 46.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BC3131;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,42.7c1-0.3,2-0.6,3-0.9c0.6-0.2,3.9-1.3,1-0.3c2.1-0.8,4.4-1.2,6.6-1.7c4.3-1.1,8.6-2,13-2.9 c9.2-1.9,18.6-3.5,28-4.8c20.3-2.8,40.7-4.5,61.1-5.5c10.5-0.6,21.1-0.9,31.6-1.1c5.3-0.1,10.7-0.2,16-0.2c0.7,0,1.3,0,2-0.1 c-2.2,0-0.5,0,0,0c1.3,0,2.7,0,4,0c2.8,0,5.7,0,8.5,0c21.2,0.1,42.4,0.7,63.5,1.5c41.4,1.7,82.6,4.4,123.9,6.4 c44.1,2.1,88.1,3.3,132.3,2.4c44.5-1,88.9-4.3,133.2-8.6c6.5-0.6,12.9-1.3,19.5-2c5.8-0.6,10.7-6.9,9.6-12.7 c-1.2-6.1-6.5-10.2-12.7-9.6c-45.9,4.7-91.8,8.7-138,10.1c-10.2,0.4-20.5,0.5-30.7,0.7c-1.3,0-2.5,0-3.8,0c-0.6,0-1.3,0-1.9,0.1 c-1.7,0.1,1.9-0.1,0.2,0c-2.7,0-5.4,0-8.1,0c-5.1,0-10.3,0-15.4-0.1c-22.2-0.2-44.5-1-66.7-1.9c-42.1-1.9-84-4.7-126.1-6.5 c-43.4-1.9-86.9-2.8-130.3-1.3C102,5.1,61.9,8.2,23.5,18.1c-4.7,1.2-9.6,2.6-14.2,4c-5.6,1.7-8.4,9.6-5.9,14.8 C6.1,42.8,11.9,44.6,18,42.7L18,42.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineRed);
export default __webpack_public_path__ + "static/media/Line-Red.051618fbdd3ea449952fe42e8bd15393.svg";
export { ForwardRef as ReactComponent };